export default __webpack_public_path__ + "static/media/check-mark.976f59de.svg";